import { FC, useContext,memo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { sp_treatments_data } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

type Props = {
  data: sp_treatments_data;
  refreshListing: () => void;
  index:number
};

const PharmacyTableRow: FC<Props> = ({
  data,
  refreshListing,
  index
}) => {
  const { isManufacturer } = useContext(AuthContext);
   const toggleIconRef = useRef<HTMLElement | null>(null);
    const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);
  
    useOnClickOutside(toggleIconRef, () => {
      changeInfoIconIndex(-1);
    });
  //.log("PharmacyTableRow.....",data)
  return (
    <tr>
      {/* Patient Name */}
      {/* {data.patient_name !== "Redacted" ? (
        <td className="text-center align-middle">
          <Link to={`/global_patients/${data.patient_id}${isManufacturer ? "" : "/edit"}`}>
            {data.patient_name}
          </Link>
        </td>
      ) : (
        <td className="text-center align-middle">{data.patient_name}</td>
      )} */}

      {/* Patient ID */}
      <td className="text-center align-middle">
        <Link 
          to={`/global_patients/${data.patient_id}${isManufacturer ? "" : "/edit"}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {data.patient_id}
        </Link>
      </td>

      {/* Case ID */}
      <td className="text-center align-middle">
        <Link 
          to={`/cases/detail/${data.bi_case_id}`}
          className={`${data.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}  
        >
          {data.bi_case_id}
        </Link>
      </td>
      <td className="text-center align-middle">
      {data.drug_name === "iovera°" ? data.drug_name : data.drug_name === "zilretta" ?  data.drug_name.toUpperCase() : data.drug_name}

       {/* {data.drug_name === "iovera°" ? data.drug_name : data.drug_name.toUpperCase()} */}
      </td>
        <td className="text-center align-middle">
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip className="custom-tooltip">
                            {data && data.practice &&(
                                <>
                                    <p><strong>Practice Name:</strong> {data.practice.name}</p>
                                    <p><strong>Address:</strong> {data.practice.address}</p>
                                    <p><strong>Phone:</strong> {data.practice.phone_number}</p>
                                    <p><strong>Fax:</strong> {data.practice.fax_number}</p>
                                </>
                            )}
                        </Tooltip>
                    }
                >
                      <span
                          className="text-link text-blue link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover">
                        {data.provider}
                      </span>
                </OverlayTrigger>
            </>
        </td>
      <td className="text-center align-middle">{data.date_transferred}</td>
       <td className="text-center align-middle">
           
                {data.sp_status}
          
      </td>
      <td className="text-center align-middle">
          {/* {data.sp_substatus} */}
          <span className={`badge background-color-${data.sp_substatus && data.pharmacy_sp_status_color}`}>
                {data.sp_substatus}
           </span>
      </td>
      

      {/* Next Steps (buttons) */}
      {/* <td className="text-center align-middle">
       <ManufacturerNextStepActions refreshListing={refreshListing} kase={data} next_steps={data.next_steps}/>
      </td> */}
    

      {/* Rest of columns */}
      <td className="text-center align-middle">{isManufacturer ? data.sp_transferred_to : data.sp_transfered_to}</td>
      
      <td className="text-center align-middle">{data.status_update?.status && (
        <span title={data.status_update.status}>
          <i className="fas fa-info-circle fa-lg text-color-yellow" style={{ color: "#f2ba45" }}></i>
        </span>
      )}</td>
      <td className="text-center align-middle">{data.date_shipped}</td>
      {/* <td className="text-center align-middle">{data.carrier}</td>
      <td className="text-center align-middle">{data.tracking_number}</td> */}
  {/* Status */}
     
    </tr>
  );
};

export default memo(PharmacyTableRow);
